import Vue from "vue";
import VueRouter from "vue-router";
import { hostPathSuffix } from "./router-redirect";

Vue.use(VueRouter);

const compilePath = function(suffix) {
    return hostPathSuffix() + suffix;
};

const routes = [
    {
        path: compilePath("/"),
        name: "home",
        component: () => import(/* webpackPrefetch: true */ "@/views/HomeView.vue"),
        meta: {
            title: "Home"
            }
    },
    {
        path: compilePath("/offers"),
        name: "offers",
        component: () => import(/* webpackPrefetch: true */ "@/views/OffersView.vue"),
        meta: {
            title: "Offers"
        }
    },
    {
        path: compilePath("/about-you"),
        name: "about-you",
        component: () => import(/* webpackPrefetch: true */ "@/components/AboutYou.vue"),
        meta: {
            title: "Get Started",
            steps: [ "ABOUT_YOU" ]
        }
    },
    {
        path: compilePath("/reserve-appointment"),
        name: "reserve-appointment",
        component: () => import(/* webpackPrefetch: true */ "@/components/AvailabilityWrapper.vue"),
        meta: {
            title: "Reserve your Appointmenr",
            steps: [ "FILTERS", "AVAILABILITY" ]
        }
    },
    {
        path: compilePath("/checkout"),
        name: "checkout",
        component: () => import(/* webpackPrefetch: true */ "@/components/CheckOut.vue"),
        meta: {
            title: "Checkout",
            steps: [ "CHECKOUT" ]
        }
    },
    {
        path: compilePath("/finished"),
        name: "finished",
        component: () => import(/* webpackPrefetch: true */ "@/components/FinishedPage.vue"),
        meta: {
            title: "Finished",
            steps: [ "FINISHED" ]
        }
    },
    {
        path: compilePath("/cancel"),
        name: "cancel",
        component: () => import(/* webpackPrefetch: true */ "@/components/CancelPage.vue"),
        meta: {
            title: "Booking Cancelled",
            steps: [ "FINISHED" ]
        }
    },
];

const mode = window.location.hostname == "localhost" ? "hash" : "history";
const router = new VueRouter({ mode, routes, base: __dirname });

export default router;
